import msg from 'msg';

export const getShelfLifeTitle = (minimumShelfLife, averageShelfLife) => {
  if (!minimumShelfLife && !averageShelfLife) return '';
  const { toolTip } = msg.newShelfLife;
  return toolTip;
};
